<template>
  <div>
    <air-table
      ref="airTable"
      class="table-v2"
      :show-checkbox="false"
      :show-seq="false"
      :show-operation="false"
      :columns="columns"
      :tree-config="{children: 'children'}"
      :data="getTableData"
      small-empty
    >
    </air-table>
    <div class="informations">
      <div class="information-item">
        <div class="title">{{ $t('notes') }}</div>
        <div class="color-primary">{{ $t('upperLimitOfTaxExemptionTip') }}</div>
      </div>
      <div class="information-item">
        <div class="title">{{ $t('relatedPolicyLinks') }}</div>
        <div>
          <a class="link" :href="item.policyLink" target="_blank" v-for="item in getLinks" :key="item.id">《{{ item.policyName }}》</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PayPolicy",
    props: {
      datas: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        columns: []
      }
    },
    created() {
      this.getColumns();
    },
    methods: {
      getColumns() {
        let columns = [
          { title: this.$t('year'), field: 'year', minWidth: 120, align: 'center', fixed: 'left'},
          {
            title: this.$t('minimumWage'), align: 'center', isGroup: true,
            children: [
              { title: this.$t('effectiveDate'), field: 'startDateMin', minWidth: 120, align: 'center' },
              { title: this.$t('expiryDate'), field: 'endDateMin', minWidth: 120, align: 'center' },
              { title: this.$t('salaryType'), field: 'type', minWidth: 120, align: 'center' },
              { title: this.$t('amount'), field: 'miniMoney', minWidth: 120, align: 'center', money: true }
            ]
          },
          {
            title: this.$t('monthlySalary'), align: 'center', isGroup: true,
            children: [
              { title: this.$t('effectiveDate'), field: 'startDate', minWidth: 120, align: 'center' },
              { title: this.$t('expiryDate'), field: 'endDate', minWidth: 120, align: 'center' },
              { title: this.$t('amount'), field: 'monthAverageWage', minWidth: 120, align: 'center', money: true }
            ]
          },
          {
            title: this.$t('taxExemptAmountForSeverancePay'), align: 'center', isGroup: true,
            children: [
              { title: this.$t('effectiveDate'), field: 'startDate', minWidth: 120, align: 'center' },
              { title: this.$t('expiryDate'), field: 'endDate', minWidth: 120, align: 'center' },
              { title: this.$t('amount'), field: 'dimissionAllowance', minWidth: 120, align: 'center', money: true }
            ]
          }
        ];
        this.columns = columns;
      }
    },
    computed: {
      getLinks() {
        const { policyLink } = this.datas;
        return policyLink || [];
      },
      getTableData() {
        const tableData = [];
        const { minSalary, avgMonthSalary } = this.datas;
        let obj = {}
        if (minSalary && minSalary.length) {
          minSalary.forEach(item => {
            if (!obj[item.year]) {
              const itemObj = {
                ...item,
                startDateMin: item.startDate,
                endDateMin: item.endDate
              }
              delete itemObj.startDate;
              delete itemObj.endDate;
              obj[item.year] = itemObj;
            }
          })
        }
        if (avgMonthSalary && avgMonthSalary.length) {
          avgMonthSalary.forEach(item => {
            if (!obj[item.year]) {
              obj[item.year] = {
                ...item
              }
            } else {
              obj[item.year] = {
                ...obj[item.year],
                ...item
              }
            }
          })
        }
        Object.keys(obj).forEach(item => {
          tableData.push(obj[item]);
        })
        return tableData;
      }
    }
  }
</script>

<style scoped>

</style>

